import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { PowerRenewableHeroBGC } from "../../constant";

export default function PowerAndRenewableLanding() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "50vh", md: "80vh" },
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Background Video */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh", // Use dvh for mobile browsers
          minHeight: "-webkit-fill-available", // Better mobile support
          zIndex: -1,
          overflow: "hidden",
          pointerEvents: "none",
          background: "black",
          "::after": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
          },
        }}
      >
        <video
          autoPlay
          loop
          muted
           playsInline
  preload="metadata"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
           // transform: "scaleX(-1)",
            //filter: "brightness(0.7)",
            minHeight: "-webkit-fill-available",
          }}
        >
          <source src={PowerRenewableHeroBGC} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {/* Content Overlay */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          height: "100%",
          padding: { xs: 2, sm: 4, md: 6 },
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          margin: "0 auto",
          alignItems: "center",
        }}
      >
        {/* Title Box */}
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          sx={{
            width: "100%",
            maxWidth: "1200px",
            textAlign: "left",
            py: 4,
            mt: 4,
          }}
        >
          <Grid container spacing={0}>
            <Grid xs={12} sm={12} md={8} lg={8}>
              <Typography
                variant="h2"
                sx={{
                  background: 'linear-gradient(262.41deg, #1DA1F2 -8.32%, #6843EC 93.3%)',
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: { xs: "24px", sm: "32px", md: "48px" },
                  fontWeight: 700,
                  mb: 2,
                  textAlign: "start",
                  letterSpacing: isMobile ? "0px" : "-2.4px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {`Building Smarter Power & Renewable Operations.`}
              </Typography>
            </Grid>
            <Grid xs={12} sm={12} md={6} lg={6}>
              <Typography
                  sx={{
                    color: "#fff",
                    fontSize: { xs: "14px", md: "16px" },
                    lineHeight: 1.8,
                    textAlign: "start",
                    marginTop: 5,
                  }}
                >
{"As energy systems become more complex, organizations need greater control over assets, workforce, environmental commitments, and operational performance. iEnergy provides a unified platform that supports asset monitoring, contractor management, EHS, ESG, sustainability reporting, and operational governance across power plants, transmission networks, and renewable energy facilities. Helping energy providers deliver reliable power while advancing sustainability and business performance. "}                </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}